import { render } from "./journaliesPayements.vue?vue&type=template&id=8787b166"
import script from "./journaliesPayements.vue?vue&type=script&lang=js"
export * from "./journaliesPayements.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__